import createSharedComposable from '@nicolaudie-group/ng-ui-kit/helpers/createSharedComposable'
import useStorage from '@nicolaudie-group/ng-ui-kit/composables/useStorage'

export const MODE_PALETTE = 'palette'
export const MODE_CUSTOM = 'custom'

function useColorpickerMode() {
  return useStorage(
    'colorpicker-display-mode',
    MODE_CUSTOM,
  )
}

/*
Use a shared reactivity scope, so that changes made by a component to the value
are tracked between all other components using it within the same browser context
*/
export default createSharedComposable(useColorpickerMode)
